import React, { useEffect, useState, forwardRef } from "react";
import axios from "./axios";
import "./Row.css";
import FlipMove from "react-flip-move";
import YouTube from "react-youtube";
const movieTrailer = require("movie-trailer");

const base_url = "https://image.tmdb.org/t/p/original/";

const Row = forwardRef(({ title, fetchUrl, isLargeRow = false }, ref) => {
    const [movies, setMovies] = useState([]);
    const [trailerUrl, setTrailerUrl] = useState("");

    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(fetchUrl);
            setMovies(request.data.results);
            return request;
        }
        fetchData();
    }, [fetchUrl]);

    const handleClick = (movie) => {
        if (trailerUrl) {
            setTrailerUrl("");
        } else {
            movieTrailer(movie?.name || "")
                .then((url) => {
                    const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlParams.get("v"));
                })
                .catch((e) => console.log(e));
        }
    };

    const opts = {
        height: "390",
        width: "100%",
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    return (
        <div className="row">
            <h2>{title}</h2>

            <FlipMove className="row__posters">
                {movies.map(
                    (movie) =>
                        ((isLargeRow && movie.poster_path) ||
                            (!isLargeRow && movie.backdrop_path)) && (
                            <img
                                ref={ref}
                                onClick={() => handleClick(movie)}
                                className={`row__poster ${isLargeRow && "row__posterLarge"}`}
                                key={movie.id}
                                src={`${base_url}${
                                    isLargeRow ? movie.poster_path : movie.backdrop_path
                                    }`}
                                alt={movie.name}
                            />
                        )
                )}
            </FlipMove>
            {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
        </div>
    );
});

export default Row;
